export default "__VITE_ASSET__baa24abf__"